export default "__VITE_ASSET__8f98ba1a__"